import type { UntypedFormControl } from '@angular/forms';
import type { CustomLabels } from '@web/widgets/timer/type/timer-widget.type';

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { WebBaseControlSettingsComponent } from '@web/widgets/common/abstract/web-base-control-settings.component';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';

@Component({
    selector: 'web-timer-legend-setting',
    templateUrl: './timer-legend-setting.component.html',
    styleUrls: ['./timer-legend-setting.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule],
})
export class TimerLegendSettingComponent extends WebBaseControlSettingsComponent<CustomLabels> {
    protected initForm(): void {
        this.form = this.fb.group({
            days: null,
            hours: null,
            minutes: null,
            seconds: null,
        });
    }

    protected setFormData(): void {
        this.form.patchValue(this.item, { emitEvent: false });
    }

    public get days(): UntypedFormControl {
        return this.form.get('days') as UntypedFormControl;
    }

    public get hours(): UntypedFormControl {
        return this.form.get('hours') as UntypedFormControl;
    }

    public get minutes(): UntypedFormControl {
        return this.form.get('minutes') as UntypedFormControl;
    }

    public get seconds(): UntypedFormControl {
        return this.form.get('seconds') as UntypedFormControl;
    }
}
